var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
}; // @ts-ignore


import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
import { guid, isRtl, getTabIndex, validatePackage, kendoThemeMaps // useDir,
} from '@progress/kendo-vue-common';
import { packageMetadata } from '../package-metadata'; // tslint:enable:max-line-length

var TextAreaVue2 = {
  name: 'KendoTextArea',
  model: {
    event: 'changemodel'
  },
  // @ts-ignore
  emits: {
    'input': null,
    'change': null,
    'changemodel': null,
    'update:modelValue': null,
    'focus': null,
    'blur': null
  },
  props: {
    ariaDescribedBy: String,
    ariaLabelledBy: String,
    autoSize: Boolean,
    modelValue: {
      type: [String, Array, Number],
      default: undefined
    },
    defaultValue: [String, Number],
    dir: String,
    disabled: Boolean,
    readOnly: Boolean,
    rows: Number,
    id: String,
    name: String,
    validationMessage: String,
    size: {
      type: String,
      default: 'medium',
      validator: function validator(value) {
        return [null, 'small', 'medium', 'large'].includes(value);
      }
    },
    rounded: {
      type: String,
      default: 'medium',
      validator: function validator(value) {
        return [null, 'small', 'medium', 'large', 'full'].includes(value);
      }
    },
    fillMode: {
      type: String,
      default: 'solid',
      validator: function validator(value) {
        return [null, 'solid', 'flat', 'outline'].includes(value);
      }
    },
    required: Boolean,
    placeholder: String,
    tabIndex: Number,
    valid: {
      type: Boolean,
      default: undefined
    },
    value: [String, Array, Number],
    validityStyles: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    validatePackage(packageMetadata);
    this.calculatedId = guid();
  },
  computed: {
    rootClassName: function rootClassName() {
      var _a;

      var _b = this.$props,
          size = _b.size,
          fillMode = _b.fillMode,
          rounded = _b.rounded,
          required = _b.required;
      var invalid = this.validityStyles === true ? !this.isValid : false;
      return _a = {
        'k-input': true,
        'k-textarea': true
      }, _a["k-input-" + (kendoThemeMaps.sizeMap[size] || size)] = size, _a["k-input-" + fillMode] = fillMode, _a["k-rounded-" + (kendoThemeMaps.roundedMap[rounded] || rounded)] = rounded, _a['k-disabled'] = this.$props.disabled, _a['k-invalid'] = invalid, _a['k-required'] = required, _a;
    },
    computedValue: function computedValue() {
      return this.$props.value !== undefined ? this.$props.value : this.$props.modelValue !== undefined ? this.$props.modelValue : this.currentValue;
    },
    isValid: function isValid() {
      return this.valid !== undefined ? this.valid : !this.required ? true : this.computedValue ? true : false;
    }
  },
  data: function data() {
    return {
      currentValue: this.$props.defaultValue,
      textAreaHeight: 'auto',
      currentDir: 'ltr'
    };
  },
  mounted: function mounted() {
    this.element = this.v3 ? this.elementRef : this.$refs.element;
    this.currentDir = this.$props.dir !== undefined ? this.$props.dir : isRtl(this.$el) ? 'rtl' : 'ltr';
    this.setValidity();
  },
  updated: function updated() {
    this.element = this.v3 ? this.elementRef : this.$refs.element;
    this.setValidity();
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var _this = this;

    var h = gh || createElement;
    var _a = this.$props,
        ariaDescribedBy = _a.ariaDescribedBy,
        ariaLabelledBy = _a.ariaLabelledBy,
        autoSize = _a.autoSize,
        disabled = _a.disabled,
        readOnly = _a.readOnly,
        required = _a.required,
        rows = _a.rows,
        id = _a.id,
        name = _a.name,
        placeholder = _a.placeholder,
        tabIndex = _a.tabIndex;

    var textAreaAttrs = __assign({
      id: id || this.calculatedId,
      name: name,
      disabled: disabled,
      rows: rows,
      placeholder: placeholder,
      readOnly: readOnly,
      required: required,
      tabIndex: getTabIndex(tabIndex, disabled),
      'aria-labelledby': ariaLabelledBy,
      'aria-describedby': ariaDescribedBy,
      'aria-multiline': true,
      'aria-disabled': disabled || undefined
    }, this.$attrs);

    var textarea = h('textarea', __assign(__assign({}, textAreaAttrs), {
      attrs: this.v3 ? undefined : textAreaAttrs,
      'class': 'k-input-inner',
      ref: this.v3 ? function (el) {
        _this.elementRef = el;
      } : 'element',
      style: autoSize ? {
        resize: 'none',
        overflow: 'hidden',
        height: this.textAreaHeight
      } : {},
      value: this.v3 ? this.computedValue : null,
      domProps: this.v3 ? undefined : {
        'value': this.computedValue
      },
      onChange: this.handleChange,
      onInput: this.handleInput,
      on: this.v3 ? undefined : {
        'change': this.handleChange,
        'focus': this.handleFocus,
        'blur': this.handleBlur,
        input: this.handleInput
      },
      onFocus: this.handleFocus,
      onBlur: this.handleBlur
    }));
    return h("span", {
      "class": this.rootClassName,
      dir: this.currentDir,
      attrs: this.v3 ? undefined : {
        dir: this.currentDir
      },
      style: this.$attrs.style
    }, [textarea]);
  },
  methods: {
    setValidity: function setValidity() {
      if (this.element && this.element.setCustomValidity) {
        this.element.setCustomValidity(this.isValid ? '' : this.validationMessage || '');
      }

      if (this.element) {
        this.textAreaHeight = this.element.scrollHeight + "px";
      }
    },
    focus: function focus() {
      if (this.element) {
        this.element.focus();
      }
    },
    handleChange: function handleChange(event) {
      var newValue = event.target.value;

      if (!this.$props.disabled) {
        this.textAreaHeight = 'auto';
        this.currentValue = newValue;
      }

      if (!this.$props.disabled) {
        this.$emit('changemodel', newValue);
        this.$emit('update:modelValue', newValue);
        this.$emit('change', {
          event: event,
          component: this,
          name: this.element.name,
          value: newValue
        });
      }
    },
    handleInput: function handleInput(event) {
      var newValue = event.target.value;

      if (!this.$props.disabled) {
        this.textAreaHeight = 'auto';
        this.currentValue = newValue;
      }

      if (!this.$props.disabled) {
        this.$emit('changemodel', newValue);
        this.$emit('update:modelValue', newValue);
        this.$emit('input', {
          event: event,
          component: this,
          name: this.element.name,
          value: newValue
        });
      }
    },
    handleFocus: function handleFocus(event) {
      if (!this.$props.disabled) {
        this.$emit('focus', {
          event: event,
          component: this,
          name: this.element.name
        });
      }
    },
    handleBlur: function handleBlur(event) {
      if (!this.$props.disabled) {
        this.$emit('blur', {
          event: event,
          component: this,
          name: this.element.name
        });
      }
    }
  }
};
var TextArea = TextAreaVue2;
export { TextArea, TextAreaVue2 };